var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import styles from './ApiStatusItem.module.scss';
export var ApiStatusItem = function (props) {
    var status = props.status, isValid = props.isValid, url = props.url, name = props.name;
    var statusParsed = isValid ? 'OK' : 'KO';
    var statusText = "(status : ".concat(status, ")");
    var apiStatusItemStatusCodeClass = classNames(styles.apiStatusItemStatusCode, isValid ? styles.apiStatusItemStatusCodeOK : styles.apiStatusItemStatusCodeKO);
    return (_jsxs("li", __assign({ className: styles.apiStatusItemWrapper }, { children: [_jsxs("div", __assign({ className: styles.apiStatusItem }, { children: [_jsx("span", { children: name }), _jsx("span", __assign({ className: apiStatusItemStatusCodeClass }, { children: statusParsed }))] })), (url || status) && (_jsxs("div", __assign({ className: styles.apiStatusItemDetails }, { children: [_jsx("span", { children: url }), _jsx("span", { children: statusText })] })))] })));
};
